
<div
  class="amplify-authenticator"
  *ngIf="_show"
  data-test="sign-in-section"
  >
  <div class="amplify-form-body" data-test="sign-in-body-section">
    <div class="amplify-form-header" data-test="sign-in-header-section">
      {{ this.amplifyService.i18n().get('Sign in to your account') }}
    </div>
    <ion-list lines="none">
      <amplify-auth-username-field-ionic
        [usernameAttributes]="_usernameAttributes"
        (usernameFieldChanged)="onUsernameFieldChanged($event)"
      ></amplify-auth-username-field-ionic>
      <ion-item lines="none">
        <ion-label class="amplify-input-label" for="password" position="stacked">
          {{ this.amplifyService.i18n().get('Password *') }}
        </ion-label>
        <ion-input
          #password
          type="password"
          class="amplify-form-input"
          (input)="setPassword(password.value)"
          (keyup.enter)="onSignIn()"
          data-test="sign-in-password-input"
        ></ion-input>
      </ion-item>
    </ion-list>
    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button expand="block" color="primary"
          (click)="onSignIn()"
          data-test="sign-in-sign-in-button"
          >{{ this.amplifyService.i18n().get('Sign In') }}</ion-button>
      </div>

      <div class="amplify-form-row">
        <div class="amplify-form-signup" *ngIf="!shouldHide('SignUp')">
          {{ this.amplifyService.i18n().get('No account?') }}
          <a
            class="amplify-form-link"
            (click)="onSignUp()"
            data-test="sign-in-create-account-link"
            >
            {{ this.amplifyService.i18n().get('Create account') }}
          </a>
        </div>
        <div class="amplify-form-signup" *ngIf="!shouldHide('ForgotPassword')">
          <a class="amplify-form-link" (click)="onForgotPassword()" data-test="sign-in-forgot-password-link">
            {{ this.amplifyService.i18n().get('Reset Password') }}
          </a>
        </div>
      </div>

    </div>
  </div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
